module.exports = __webpack_public_path__ + "img/concrete.9d89a3ea.png";